var request = require('../js/request.js')

// 商城系统相关API
var ECMallApi = {
	// 获取公司信息
	getCompanyInfo: function (data) {
		return request.noPost('/library/getCompanyInfo', data)
	},
	// 获取小程序二维码
	getQrcode: function (data) {
		return request.noPost('/library/getQrcode', data)
	},
	// email 发送报警提醒
	noticeEmail: function (data) {
		return request.noPost('/library/noticeEmail', data)
	},
	// 发送通知信息至后台
	saveNotice: function (data) {
		return request.noPost('/library/saveNotice', data)
	},
	// 发送打印指令
	subPrint: function (data) {
		return request.post('/library/subPrint', data)
	},
	// 获取我的在卖商品
	getUserProduct: function (data) {
		return request.post('/library/getUserProduct', data)
	},
	// 修改商品的状态
	changeProductStatus: function(data) {
		return request.post('/library/changeProductStatus', data)
	},
	// 获取当前设备下正在售卖的商品
	getCompanyProduct: function (data) {
		return request.post('/library/getCompanyProduct', data)
	},
	// 获取商品详情
	getProductById: function (data) {
		return request.post('/library/getProductById', data)
	},
	// 开箱
	openBox: function (data) {
		return request.post('/library/openBox', data)
	},
	// 扫描二维码获取产品信息
	scanQrcode: function (data) {
		return request.post('/library/scanQrcode', data)
	},
	// 添加支付订单
	addOrder: function (data) {
		return request.post('/library/addOrder', data)
	},
	// 微信支付
	wxpay: function (data) {
		return request.post('/library/wxpay', data)
	},
}


export {
	ECMallApi
}


//////////////////
// WEBPACK FOOTER
// ./static/Bookcase/js/api.js
// module id = null
// module chunks = 